import React, { useState } from "react";
import "./Gallery.css";
import Carousel from "../Carousel/Carousel";
import bookingImg from "../../Images/Rooms/heroBedroom.jpg";
import restaurantImg from "../../Images/restaurantImage.jpg";
import restaurantLight from "../../Images/restaurantLight.jpg";
import restaurantBench from "../../Images/restaurantBench.jpg";
import hallway from "../../Images/hallway.jpg";
import rectangleImg from "../../Images/fourSeasonsStart.jpg";
// import card1 from "../../Images/Restaurant/aboutCulinary.jpg";
// import card2 from "../../Images/Restaurant/displayDesk.jpg";
// import card3 from "../../Images/Restaurant/chairs.jpg";
// import card4 from "../../Images/card_img4.png";
// import card5 from "../../Images/card_img5.png";
// import card6 from "../../Images/card_img6.png";
// import CardImg from "../Cards/CardsImg";

function importAll(r) {
    return r.keys().map(r);
}

const foodImagesArray = importAll (require.context('../../Images/Food', false, /\.(png|jpe?g|svg)$/));
const hallImagesArray = importAll (require.context('../../Images/Hall', false, /\.(png|jpe?g|svg)$/));
const nearbyImagesArray = importAll (require.context('../../Images/Nearby', false, /\.(png|jpe?g|svg)$/));
const teamImagesArray = importAll (require.context('../../Images/Team', false, /\.(png|jpe?g|svg)$/));
const restaurantImagesArray = importAll (require.context('../../Images/Restaurant', false, /\.(png|jpe?g|svg)$/));
const roomImagesArray = importAll (require.context('../../Images/Rooms', false, /\.(png|jpe?g|svg)$/));

const Gallery = () => {

  var galHeaders = [
    "Restaurant",
    "Food",
    "Rooms",
    "Hall",
    "Our Team",
  ];
  const [currentGalleryHeader, setCurrentGalleryHeader] = useState("Restaurant");
  const [currentGalleryArray, setCurrentGalleryArray] = useState([...restaurantImagesArray]);
  const nearbyGalleryArray = [...nearbyImagesArray];
  const [showMoreGallery, setShowMoreGallery] = useState(currentGalleryArray.length > 3);
  const [numberOfImages, setNumberOfImages] = useState(window.innerWidth < 900 ? 1 : 3);
  const [numberOfImagesGallery, setNumberOfImagesGallery] = useState(window.innerWidth < 900 ? 1 : 3);

  var galArr = [
    {
      header: "Scenic Location",
      text: "Nestled in Kandra's lush greenery, surrounded by forests and serene landscapes, offering a peaceful escape from city life.",
    },
    {
      header: "Versatile Event Spaces",
      text: "Elegant halls for both professional and casual gatherings, tailored for parties, meetings, and celebrations.",
    },
    {
      header: "Diverse Stay Options",
      text: "Cozy rooms and luxurious suites, with special discounts for extended stays, ensuring comfort and value for every guest.",
    },
  ];
  var galImages = [ 
    {
      text: "DoMuhani",
      distance: "3KM"
    },
    {
      text: "Chandil Dam",
      distance: "25KM"
    },
    {
      text: "Jayanti Sarovar, Jubilee Park",
      distance: "15KM"
    }, 
    {
      text: "Chandil Dam",
      distance: "25KM"
    },
    {
      text: "Dorabji Tata Park",
      distance: "10KM"
    },
    {
      text: "Jubilee Park",
      distance: "15KM"
    }, 
    {
      text: "Kaas Phool Plantations",
      distance: "Less than 1KM"
    },
    {
      text: "Nature Trail",
      distance: "5KM"
    },
    {
      text: "Subarnarekha Nadi",
      distance: "2KM"
    }
  ];

  const showNearbyMoreHandler = () =>{
    setNumberOfImages(nearbyGalleryArray.length);
  }

  const showNearbyMoreHandlerGallery = () => {
    setNumberOfImagesGallery(currentGalleryArray.length);
    setShowMoreGallery(false);
  }

  return (
    <div className="gallery">
      <div className="gallery-intro">
        <div className="plush-text">
          <p>
            Plush bedding and modern <br /> amenities await your arrival
          </p>
        </div>
        <div className="gallery-images">
          <div className="gal-img-i">
            <img loading="lazy" src={bookingImg} alt="gallery display 1" />
          </div>
          <div className="gal-img-ii">
            <img loading="lazy" src={restaurantImg} alt="gallery display 1" />
          </div>
          <div className="gal-img-iii">
            <img loading="lazy" src={restaurantBench} alt="gallery display 1" />
          </div>
          <div className="gal-img-iv">
            <img loading="lazy" src={hallway} alt="gallery display 1" />
          </div>
          <div className="gal-img-v">
            <img loading="lazy" src={restaurantLight} alt="gallery display 1" />
          </div>
        </div>
      </div>
      {/* <div className="plush-text">
        <p>
          Plush bedding and modern <br /> amenities await your arrival
        </p>
      </div>
      <div className="gallery-images">
        <div className="gal-img-i">
          <img src={bookingImg} alt="gallery display 1" />
        </div>
        <div className="gal-img-ii">
          <img src={bookingImg} alt="gallery display 1" />
        </div>
        <div className="gal-img-iii">
          <img src={bookingImg} alt="gallery display 1" />
        </div>
        <div className="gal-img-iv">
          <img src={bookingImg} alt="gallery display 1" />
        </div>
        <div className="gal-img-v">
          <img src={bookingImg} alt="gallery display 1" />
        </div>
      </div> */}
      <div className="carousel-mobile">
        <Carousel />
      </div>
      <div className="different">
        <div>
          <div className="diff-head-text">
            What makes us {' '}
            <br className="line-break" />
            different
          </div>
          <div className="diff-features-container">
            <div className="diff-features">
              {galArr.map((item, ind) => {
                return (
                  <div
                    key={ind + Math.random() * 100}
                    className="feature-component"
                  >
                    <div className="feat-header">{item.header}</div>
                    <div className="feat-description">{item.text}</div>
                  </div>
                );
              })}
            </div>
            <img src={rectangleImg} alt="different" className="diff-img" />
          </div>
        </div>
      </div>
      <div className="gallery-header">Check Our Resort Gallery</div>
      <div className="room-tags">
        {galHeaders.map((item, ind) => {
          return (
            <div
              key={ind*Math.random()*10907}
              className="gal-header-option"
              style={{ color: `${item === currentGalleryHeader ? "red" : "black"}` }}
              onClick={
                () => {
                  setCurrentGalleryHeader(item);
                  if (item === "Restaurant") {
                    const tempArr = [...restaurantImagesArray];
                    setCurrentGalleryArray(tempArr);
                    setShowMoreGallery(tempArr.length > 3);
                  }
                  if (item === "Food") {
                    const tempArr = [...foodImagesArray];
                    setCurrentGalleryArray(tempArr);
                    setShowMoreGallery(tempArr.length > 3);
                  }
                  if (item === "Hall") {
                    const tempArr = [...hallImagesArray];
                    setCurrentGalleryArray(tempArr);
                    setShowMoreGallery(tempArr.length > 3);
                  }
                  if (item === "Our Team") {
                    const tempArr = [...teamImagesArray];
                    setCurrentGalleryArray(tempArr);
                    setShowMoreGallery(tempArr.length > 3);
                  }
                  if (item === "Rooms") {
                    const tempArr = [...roomImagesArray];
                    setCurrentGalleryArray(tempArr);
                    setShowMoreGallery(tempArr.length > 3);
                  }
                  setNumberOfImagesGallery(window.innerWidth < 900 ? 1 : 3);
                }
              }
            >
              {item}
            </div>
          );
        })}
      </div>
      <hr className="division-line" />
      <div className="gallery-wrapper">
        {currentGalleryArray.slice(0, numberOfImagesGallery).map((item, index) => {
          return (
            <div key={index} className="gal-img-src">
              <img
                loading="lazy"
                src={item}
                alt={`${index} respresentational`}
                className="gal-img-src-rep"
              />
            </div>
          );
        })}
      </div>
      <div className={showMoreGallery ? 'show-more-gal-src-btn' : 'show-more-off'} onClick={showNearbyMoreHandlerGallery}>Show More</div>
      <div className="gallery-header">Check Out Nearby places</div>
      <div className="nearby-gallery">
        {nearbyGalleryArray.slice(0, numberOfImages).map((item, index) => {
          return (
            <div key={index} className="gal-img-src">
              <img
                loading="lazy"
                src={item}
                alt={`${index} respresentational`}
                className="gal-img-src-rep"
              />
              <div className="loc-specs">{galImages[index].text}</div>
              <div className="loc-dist">{galImages[index].distance}</div>
            </div>
          );
        })}
      </div>
      <div className={numberOfImages > 3 ? 'show-more-off':'show-more-gal-src-btn'} onClick={showNearbyMoreHandler}>Show More</div>
    </div>
  );
};

export default Gallery;
